module.exports = __webpack_public_path__ + "img/shou.9f284e4b.png";